import { render } from "./BackGroundBlack.vue?vue&type=template&id=3d3dea42"
const script = {}
script.render = render

export default script